import axios from "axios";
export default class ApiGasLucePage {
    static async GetGasLucePage(session_uuid) {
        try {
            const result = await axios.get("/api/web-api/public/gas-e-luce", {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.response;
        }
        catch (e) {
            return false;
        }
    }
    static async UpdateGasLucePage(session_uuid, data) {
        try {
            const result = await axios.post("/api/admin/luce-e-gas-updates", data, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.status;
        }
        catch (e) {
            return false;
        }
    }
}
